import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchResult } from '@ukam/core/searchs/search-result';
import { API_BASE_URL } from '@ukam/core/tokens/api-base-url.token';
import { UpdateStatusParams } from '@ukam/core/params/update-status.params';
import { Storage, StorageSupportData } from '../models/storage';
import { StorageParams } from '../params/storage.params';

@Injectable({ providedIn: 'root' })
export class StorageApiService {
  private readonly apiBaseUrl = inject(API_BASE_URL);
  private readonly http = inject(HttpClient);
  private readonly url = `${this.apiBaseUrl}/storages`;

  search(filter: Record<string, unknown>): Observable<SearchResult<Storage>> {
    return this.http.post<SearchResult<Storage>>(`${this.url}/search`, filter);
  }

  /** Lista completa (company + padrão da plataforma), não paginada. */
  list(): Observable<Storage[]> {
    return this.search({ unpaged: true, limit: 0 }).pipe(map(r => r?.items ?? []));
  }

  getById(id: string): Observable<Storage> {
    return this.http.get<Storage>(`${this.url}/${id}`);
  }

  create(params: StorageParams): Observable<Storage> {
    return this.http.post<Storage>(this.url, params);
  }

  update(id: string, params: StorageParams): Observable<Storage> {
    return this.http.put<Storage>(`${this.url}/${id}`, params);
  }

  updateStatus(id: string, params: UpdateStatusParams): Observable<Storage> {
    return this.http.patch<Storage>(`${this.url}/${id}/status`, params);
  }

  recalculateUsage(id: string): Observable<Storage> {
    return this.http.post<Storage>(`${this.url}/${id}/recalculate-usage`, {});
  }

  delete(id: string): Observable<unknown> {
    return this.http.delete(`${this.url}/${id}`);
  }

  getSupport(): Observable<StorageSupportData> {
    return this.http.get<StorageSupportData>(`${this.url}/support`);
  }
}
